<template>
    <div class="mobile-search-filters">
        <autocomplete-filter
            v-if="['estate', 'construction'].includes(section) && config.mode == 'autocomplete'"
            :config="config"
            :config_map="config_map"
            :contract="filters.contract ? filters.contract : ''"
            :districts="districts"
            :filters="filters"
            :geo_data="geo_data"
            :placeholder="placeholder"
            :polygon_id="filters.polygon_id"
            :searchData="searchData"
            :section="section"
            :sector="filters.sector ? filters.sector : ''"
            @input="updateGeo"
            @updated="filtersUpdated"
        />

        <div class="form-group" v-if="section === 'estate' && config.mode == 'select'">
            <div class="form-row">
                <div class="col-12">
                    <geo-select
                        :contract="filters.contract ? filters.contract : ''"
                        :section="section"
                        :sector="filters.sector ? filters.sector : ''"
                        :searchData="searchData"
                        :config="config"
                        :config_map="config_map"
                        @input="updateGeo"
                    ></geo-select>
                </div>
            </div>
        </div>

        <div class="form-group" v-if="section == 'estate'">
            <div class="form-row">
                <div class="col-6">
                    <filter-select
                        v-if="section == 'estate'"
                        v-model="filters.contract"
                        :allow-empty="false"
                        :items="filterValues.contracts"
                        :label="lang.labels.contract | capitalize"
                        name="contract"
                    />
                </div>
                <div class="col-6">
                    <filter-select
                        v-if="section == 'estate'"
                        v-model="filters.type"
                        :items="filterValues.types_list"
                        :label="lang.labels.type | capitalize"
                        name="type" clearable
                    />
                </div>
            </div>
        </div>

        <div class="form-group" v-if="section == 'estate'">
            <div class="form-row">
                <div class="col-6">
                    <my-input v-model="min_price" type="text" :label="lang.labels.min_price" @input="formatValue($event,'min_price')"/>
                    <input type="hidden" name="min_price" v-model="numeric_min_price" />
                </div>
                <div class="col-6">
                   <my-input v-model="max_price" type="text" :label="lang.labels.max_price" @input="formatValue($event,'max_price')" />
                    <input type="hidden" name="max_price" v-model="numeric_max_price" />
                </div>
            </div>
        </div>

        <div class="form-group" v-if="section == 'estate'">
            <div class="form-row">
                <div class="col-6">
                    <my-input v-model="min_surface" type="text" :label="lang.labels.min_surface" @input="formatValue($event,'min_surface')" />
                    <input type="hidden" name="min_surface" v-model="numeric_min_surface" />
                </div>
                <div class="col-6">
                    <my-input v-model="max_surface" type="text" :label="lang.labels.max_surface" @input="formatValue($event,'max_surface')" />
                    <input type="hidden" name="max_surface" v-model="numeric_max_surface" />
                </div>
            </div>
        </div>

        <div class="form-group" v-if="section == 'estate'">
            <div class="form-row">
                <div class="col-6">
                    <my-input v-model="filters.min_rooms" name="min_rooms" type="number" :label="lang.labels.min_rooms_mobile | capitalize" />
                </div>
                <div class="col-6">
                    <my-input v-model="filters.max_rooms" name="max_rooms" type="number" :label="lang.labels.max_rooms_mobile | capitalize" />
                </div>
            </div>
        </div>

        <secondary-filters
            ref="secondary_filters"
            v-if="section == 'estate'"
            :config="config"
            :filters="filters"
            :filter-values="filterValues"
            :lang="lang"
        />

        <div class="apply-filters" v-if="$root.is_mobile">
            <button class="btn btn-network undo btn-sm" @click="filtersReset">
                {{ lang.labels.reset }}
            </button>
            <button class="btn btn-network btn-sm float-right" @click.prevent="filtersUpdated">
                {{ lang.labels.search }}
            </button>

        </div>
    </div>
</template>

<script>
import Autocomplete from './filters/Autocomplete'
import FilterSelect from './filters/Select'
import SecondaryFilters from './filters/SecondaryFilters'
import { numberFormat , getNumber} from '../../helpers/numbers'
import GeoSelect from '../GeoSelect'

export default {
    components: {
        'autocomplete-filter': Autocomplete,
        'filter-select': FilterSelect,
        'secondary-filters': SecondaryFilters,
        'geo-select': GeoSelect,
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        config_map: {
            type: Object,
            required: true,
        },

        districts: {
            type: Array,
            required: false,
        },

        filters: {
            type: Object,
            required: true,
        },

        filterValues: {
            type: Object,
            required: true,
        },

        geo_data: {
            type: Object,
            required: true,
        },

        lang: {
            type: Object,
            required: true,
        },

        placeholder: {
            type: String,
            required: false,
        },

        searchData: {
            type: Object,
            required: true,
        },

        section: {
            type: String,
            required: true,
        },
    },

    data(){
        return{
            min_price: null,
            max_price: null,
            min_surface: null,
            max_surface: null,
        }
    },
    computed:{
        numeric_min_price(){
            return this.valueUpdate('min_price')
        },

        numeric_max_price(){
            return this.valueUpdate('max_price')
        },   
        numeric_min_surface(){
            return this.valueUpdate('min_surface')
        },
        numeric_max_surface(){
            return this.valueUpdate('max_surface')
        },       
    },

    mounted(){
        this.min_price = this.filters.min_price 
            ? this.numberFormat(this.filters.min_price) 
            : null;

        this.max_price = this.filters.max_price 
            ? this.numberFormat(this.filters.max_price) 
            : null;

        this.min_surface = this.filters.min_surface 
            ? this.numberFormat(this.filters.min_surface) 
            : null;

        this.max_surface = this.filters.max_surface 
            ? this.numberFormat(this.filters.max_surface) 
            : null;
    },

    methods: {
        updateGeo(event) {
            this.$emit('update-geo', event)
        },

        numberFormat(number) {
            return numberFormat(number, 0 , ',', '.')
        },

        formatValue(event,key){
            let new_key = getNumber(event)

            if(new_key == this[key]){
                this[key] = event
            }
            this.$nextTick(()=>{
                this[key] = this.numberFormat(new_key)
            })

        },

        filtersUpdated(event) {
            this.$emit('filters-updated', event)

            window.events.$emit('primary-filters-update')

            window.events.$emit('hideModal', { name: 'estates_search_filters' })
        },

        filtersReset() {
            this.$refs.secondary_filters.filtersReset()

            this.$emit('filters-updated', event)

            window.events.$emit('primary-filters-update')

            window.events.$emit('hideModal', { name: 'estates_search_filters' })
        },

        valueUpdate(field) {
            if(this[field] != null)
            {
                if(getNumber(this[field]) > 0)
                {
                    this.filters[field] = getNumber(this[field]);
                }
                else
                {
                    this.filters[field] = null;
                }
            }
            return this.filters[field];
        }
    },
}
</script>
